import React from 'react';

import { ISelectProps, Select } from '@rbilabs/components-library';
import { FieldProps } from 'formik';

export const FormikSelect: React.FC<
  FieldProps<string, { [key: string]: string }> & ISelectProps
> = ({ field, form, ...props }) => {
  return (
    <Select
      {...field}
      errorMessage={
        form.touched[field.name] && form.errors[field.name] ? form.errors[field.name] : undefined
      }
      {...props}
    />
  );
};
